import React from "react";
import "./AstroVastu.css";
import vastuBanner from "../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../components/BlogSlider";
import ServiceProduts from "../components/ServiceProduts";
import ContactForm from "../components/ContactForm";

const Muhurta = () => {
  return (
    <div className="services-page">
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       


        <h2>Shubh Muhurat 2025 – Auspicious Timings for Success</h2>
    
            <p>In Hindu astrology, <strong>Muhurat</strong> (auspicious timing) plays a crucial role in ensuring prosperity and success in personal and professional endeavors. Whether it's <strong>buying a car, opening a shop, performing Griha Pravesh (housewarming), marriage, or starting a new business</strong>, choosing the right <strong>Shubh Muhurat</strong> aligns cosmic energies for favorable outcomes.</p>
            
            <p>At <strong>Jyotish Karmaa</strong>, our expert astrologers analyze <strong>planetary positions, Nakshatras, and Lagna (ascendant)</strong> to provide the most accurate <strong>today's Shubh Muhurat, Griha Pravesh Muhurat 2025, Vivah Muhurat, and more</strong>.</p>
            
            <div class="highlight-box">
                <h3>Why Follow Shubh Muhurat?</h3>
                <ul>
                    <li>Ensures success and minimizes obstacles</li>
                    <li>Aligns activities with favorable planetary influences</li>
                    <li>Brings prosperity, health, and harmony</li>
                </ul>
            </div>
    
            <h2>Key Factors in Muhurat Selection</h2>
            <ol>
                <li><strong>Nakshatra Alignment</strong> – Auspicious Nakshatras like <strong>Rohini, Uttara Phalguni, Chitra, Pushya, and Revati</strong> are preferred.</li>
                <li><strong>Planetary Positions</strong> – Benefic planets like <strong>Jupiter (Guru) and Venus (Shukra)</strong> enhance positivity.</li>
                <li><strong>Lagna (Ascendant)</strong> – Strengthens the Muhurat's impact.</li>
                <li><strong>Avoiding Inauspicious Times</strong> – <strong>Rahu Kaal, Amavasya, and Bhadra</strong> are strictly avoided.</li>
            </ol>
    
            <h2>Car Purchase Muhurat – March 2025</h2>
            <p>Buying a car in an <strong>auspicious Muhurat</strong> ensures safety, longevity, and prosperity. Here are the best dates in <strong>March 2025</strong>:</p>
            
            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Nakshatra</th>
                        <th>Auspicious Time</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>2nd March 2025</td>
                        <td>Revati</td>
                        <td>08:59 AM – 09:01 PM</td>
                    </tr>
                    <tr>
                        <td>6th March 2025</td>
                        <td>Rohini</td>
                        <td>10:50 AM – 06:40 AM (next day)</td>
                    </tr>
                    <tr>
                        <td>7th March 2025</td>
                        <td>Mrigashirsha</td>
                        <td>06:40 AM – 09:18 AM</td>
                    </tr>
                    <tr>
                        <td>9th March 2025</td>
                        <td>Punarvasu/Pushya</td>
                        <td>06:32 AM – 06:31 AM (next day)</td>
                    </tr>
                    <tr>
                        <td>17th March 2025</td>
                        <td>Chitra/Swati</td>
                        <td>06:26 AM – 07:32 PM</td>
                    </tr>
                    <tr>
                        <td>27th March 2025</td>
                        <td>Shatabhisha</td>
                        <td>06:18 AM – 11:03 PM</td>
                    </tr>
                </tbody>
            </table>
    
                    <h2>Griha Pravesh Muhurat 2025 – Housewarming Dates</h2>
                    <p>Entering a new home at the <strong>right Muhurat</strong> ensures happiness, wealth, and peace. Below are the <strong>best Griha Pravesh Muhurats in 2025</strong>:</p>
                    
                    <ul>
                        <li><strong>6th Feb 2025</strong> – Dashmi (Rohini) – 10:53 PM to 7:06 AM (next day)</li>
                        <li><strong>14th Feb 2025</strong> – Tritiya (Uttara Phalguni) – 11:09 PM to 6:59 AM (next day)</li>
                        <li><strong>1st Mar 2025</strong> – Dwitiya/Tritiya (Uttara Bhadrapada) – 11:22 AM to 6:45 AM (next day)</li>
                        <li><strong>6th Mar 2025</strong> – Saptami (Rohini) – 6:41 AM to 10:50 AM</li>
                        <li><strong>15th Mar 2025</strong> – 6:59 AM to 11:52 PM</li>
                        <li><strong>12th Apr 2025</strong> – Dashami (Chitra) – 9:15 AM to 2:30 PM</li>
                        <li><strong>1st May 2025</strong> – Panchami (Mrigashirsha) – 11:23 AM to 2:21 PM</li>
                        <li><strong>7th May 2025</strong> – Ekadashi (Uttara Phalguni) – 6:17 PM to 5:35 AM (next day)</li>
                        <li><strong>10th May 2025</strong> – Trayodashi (Chitra) – 5:33 AM to 5:29 PM</li>
                    </ul>
                    
                    <p><em>(For full-year Muhurat details, consult our astrologers.)</em></p>
                    
                    <h2>Today's Shubh Muhurat & Other Important Muhurats</h2>
                    <ul>
                        <li><strong>Shop Opening Muhurat Today</strong></li>
                        <li><strong>Marriage (Vivah) Muhurat Today</strong></li>
                        <li><strong>Abhijit Muhurat Today</strong></li>
                        <li><strong>Best Time for Puja & Investments</strong></li>
                    </ul>
                    
                    <p>Stay updated with <strong>Jyotish Karmaa's daily Muhurat predictions</strong> for the most <strong>accurate and personalized astrological guidance</strong>.</p>
                    
                    <h3>Consult Our Expert Astrologers</h3>
                    <p>For personalized <strong>Muhurat recommendations</strong>, contact <strong>Jyotish Karmaa</strong> and ensure success in all your ventures!</p>
                    
                    <div class="highlight-box">
                        <h3>Why Choose Jyotish Karmaa?</h3>
                        <ul>
                            <li>✅ <strong>Vedic Astrology-Based Predictions</strong></li>
                            <li>✅ <strong>Accurate Planetary & Nakshatra Analysis</strong></li>
                            <li>✅ <strong>Customized Muhurat for All Occasions</strong></li>
                        </ul>
                        
                        <a href="#" class="cta-button">Visit JyotishKarmaa.com for Today's Shubh Muhurat!</a>
                    </div>

        {/* FAQs */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq"><h4>What is Astro Vastu?</h4><p>Astro Vastu combines Vastu Shastra with astrology to bring personalized solutions based on your birth chart.</p></div>
          <div className="faq"><h4>Can this service be done remotely?</h4><p>Yes, we offer remote consultations through video calls and shared floor plans.</p></div>
          <div className="faq"><h4>How do I choose a gemstone?</h4><p>We analyze your birth chart and planetary positions to recommend suitable gemstones.</p></div>
          <div className="faq"><h4>What is the benefit of Rudraksha?</h4><p>Rudraksha beads help in spiritual growth and balancing chakras and energy fields.</p></div>
        </div>

        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

      </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src="/assets/profile/Jyotish_karam_profile.jpeg" alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>

       <ContactForm />

       
          <ServiceProduts />
        
      </div>
    </div>
  );
};

export default Muhurta;
